import { FullPageSpinner } from "@/components/ui/loading/full-page-spinner";
import { HeaderRoot, HeaderTitle } from "@/components/ui/layout/header/header";
import { Page } from "@/components/ui/layout/page/page";

import type { JSX } from "react";

interface PendingComponentProps {
  title: string;
}

export const PendingComponent = ({ title }: PendingComponentProps): JSX.Element => {
  return (
    <>
      <HeaderRoot>
        <HeaderTitle title={title} align="center" />
      </HeaderRoot>
      <Page>
        <FullPageSpinner />
      </Page>
    </>
  );
};
